module.exports = __webpack_public_path__ + "img/category_5nin.153a1ee5.jpg";